/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactElement, ReactNode } from 'react';
import Card from '@userzoomlibraries/toolkit-card';
import { PADDINGS } from '@userzoomlibraries/toolkit-themes-userzoom-platform-card';

type Props = {
	className?: string;
	children: ReactNode;
};

const defaultProps = {
	className: '',
};
const PageCard = ({ className, children }: Props): ReactElement => (
	<Card className={className} hPadding={PADDINGS.LARGE} vPadding={PADDINGS.LARGE} withShadow>
		<Card.Content>{children}</Card.Content>
	</Card>
);

PageCard.defaultProps = defaultProps;

export default PageCard;
